<div class="d-flex justify-content-center">
	<div style="width: 400px">
		<div class="card card-border-color card-border-color-primary p-shadow-8" *ngIf="eGiftVenue">
			<div class="card-header text-center flex-column">
				<img
					*ngIf="eGiftVenue.logoS3Key"
					class="w-100"
					[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + eGiftVenue.venueKey + '/' + eGiftVenue.logoS3Key"
				/>
				<img
					*ngIf="!eGiftVenue.logoS3Key"
					class="w-100"
					[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueKey + '/logo.png'"
				/>
				<div
					class="disclaimer"
					*ngIf="eGiftVenue && eGiftVenue.headerMessage"
					[style.background-color]="eGiftVenue.Venue.ooVenue.styles?.headerBgColor"
					[style.color]="eGiftVenue.Venue.ooVenue.styles?.headerTextColor"
				>
					<div>
						{{ eGiftVenue.Venue.ooVenue.name }}
					</div>
					<div style="max-width: 1200px" class="d-flex h-100 align-items-center mx-auto">
						{{ eGiftVenue.headerMessage }}
					</div>
				</div>
				<div>
					<h4>Check your gift card balance</h4>
				</div>
			</div>
			<div class="d-flex flex-column justify-content-center" [style.background-color]="eGiftVenue.Venue.ooStyles?.menuBgColor">
				<form #giftBalance="ngForm">
					<div class="mx-4 mt-2">
						<input pInputText type="text" placeholder="Gift Card #" name="giftAccount" [(ngModel)]="giftCardNumber" required class="w-100" />
					</div>
					<div class="d-flex justify-content-center">
						<p-button pRipple [disabled]="giftBalance.invalid" styleClass="p-button-raised p-button-success m-2" (click)="balanceCheck()">
							<ng-template pTemplate="content">
								<div class="d-flex justify-content-center" style="text-align: center">
									<fa-icon [icon]="['far', 'balance-scale-right']" size="lg" class="ms-1 me-2"></fa-icon>
									Check Balance
								</div>
							</ng-template>
						</p-button>
					</div>
				</form>
				<div class="m-2" style="text-align: center">
					<span *ngIf="cardBalance">
						<h3>
							{{ cardBalance | currency }}
						</h3>
					</span>
				</div>
				<div
					class="d-flex justify-content-center"
					*ngIf="transactionKey && app.deviceService.browser.toLowerCase() === 'safari' && app.deviceService.os.toLowerCase() === 'ios'"
				>
					<a [routerLink]="['../wallet/' + transactionKey]" target="_blank">
						<img src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/Add_to_Apple_Wallet_rgb_US-UK.svg" alt="Add to Apple Wallet" />
					</a>
				</div>
			</div>

			<app-venue-info-footer *ngIf="eGiftVenue.Venue.ooVenue" [ooVenue]="eGiftVenue.Venue.ooVenue" [footerMessage]="eGiftVenue.footerMessage">
			</app-venue-info-footer>
		</div>
	</div>
</div>
